import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { showAnimation } from 'src/animations';
import { ScheduleUserTask } from 'src/app/classes';
import { IIssueTransactionView } from '../../../interfaces';
import { Step, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-assign-user-form',
  templateUrl: './assign-user-form.component.html',
  styleUrls: ['./assign-user-form.component.css'],
  animations: [ showAnimation ]
})
export class AssignUserFormComponent implements IIssueTransactionView, OnDestroy, OnInit {

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject('step') private _step: Step,
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.usersControl.valueChanges.subscribe((value: ScheduleUserTask[]) => {
        this._step.visibleInConclusion = value.length > 0? true: false;
      })
    ]);
  }

  get usersControl(): AbstractControl {
    return this.formGroup.controls['users'] as AbstractControl;
  }

}
